import React from 'react'
import styles from './index.module.less'
import Portal from '@/base-components/portal'

const Dialog: React.FC<{
  visible: boolean
  title: string
  content: string
  callback: () => void
}> = ({ visible, title, content, callback }) => {
  if (!visible) {
    return <></>
  }
  return (
    <Portal
      visible={visible}
      didMount={() => {
        const html = document.querySelector('html')
        html.style.position = 'fixed'
        html.style.left = '0'
        html.style.width = '100%'
      }}
      unMount={() => {
        const html = document.querySelector('html')
        html.style.position = ''
        html.style.left = ''
        html.style.width = ''
      }}
    >
      <>
        <div
          className={styles.dialogCover}
          onClick={() => {
            callback()
          }}
        />
        <div className={styles.dialog}>
          <header className={styles.header}>
            <i
              onClick={() => {
                callback()
              }}
            />
            <span>{title}</span>
          </header>
          <div className={styles.content}>{content}</div>
        </div>
      </>
    </Portal>
  )
}

export default Dialog
